export default __webpack_public_path__ + "static/media/a008-tip.de1c6aed.jpg";